<template>
    <div>
        <div class="tw:border tw:border-[var(--p-inputtext-border-color)] tw:rounded-md tw:overflow-hidden tw:bg-[var(--p-content-background)] tw:px-1" :class="hasError ? 'is-danger' : ''">
            <e-taglist>
                <e-tag
                    v-for="group in selectedGroups"
                    :key="group.id"
                    size="is-small"
                    closable
                    aria-close-label="Close tag"
                    close-icon="times"
                    @close="remove(group)"
                >
                    {{ group.name }}
                </e-tag>

                <Button
                    v-if="alreadySelected.length < limit"
                    :class="{ 'disabled-link': disabled }"
                    variant="text"
                    icon="pi pi-plus-circle"
                    size="small"
                    @click="openModal = true"
                />
            </e-taglist>
        </div>

        <modal-select
            ref="modalSelect"
            label="group"
            :open="openModal"
            :limit="limit"
            :filters="filters"
            :sorts="sorts"
            endpoint="group-selector-search"
            :available-view="['detail']"
            :already-selected="alreadySelected"
            :additional-include="['category']"
            base-view="detail"
            @chosen="save"
            @close="close"
        >
            <template #detail-view="{ items, selected, selectItem }">
                <div class="column is-full is-narrow has-text-left">
                    <e-table
                        ref="table"
                        :checked-rows="selected"
                        :data="items"
                        checkable
                        :focusable="limit === 1"
                        :header-checkable="limit === 0"
                        backend-sorting
                        @check="(selected, row) => selectItem(row)"
                        @select="selectItem"
                    >
                        <e-table-column v-slot="{ row: group }" ref="name" field="name" label="Name" sortable>
                            {{ group.name }}
                        </e-table-column>

                        <e-table-column
                            v-slot="{ row: group }"
                            ref="category"
                            field="category"
                            label="Category"
                            sortable
                        >
                            {{ group.category ? group.category.name : '' }}
                        </e-table-column>
                    </e-table>
                </div>
            </template>
        </modal-select>
    </div>
</template>
<script>
import ModalSelect from '@/components/modal-select/base/ModalSelect.vue';
import TextFilter from '@/components/modal-select/filters/TextFilter.js';
import QueryParamSyncForModalSelectMixin from '@/mixins/QueryParamSyncForModalSelectMixin.js';

export default {
    name: 'GroupSelect',
    components: { ModalSelect },

    mixins: [QueryParamSyncForModalSelectMixin],

    props: {
        open: {
            type: Boolean,
            required: false,
            default: false,
        },

        label: {
            type: String,
            required: false,
            default: 'Groups',
        },

        alreadySelected: {
            type: Array,
            required: false,
            default: () => [],
        },

        limit: {
            type: Number,
            required: false,
            default: 10,
        },

        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },

        enableQueryParams: {
            type: Boolean,
            required: false,
            default: false,
        },

        urlParam: {
            type: String,
            required: false,
            default: '',
        },

        endpoint: {
            type: String,
            required: false,
            default: 'groups',
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    emits: ['save', 'close', 'remove'],

    data: () => ({
        openModal: false,
        filters: [new TextFilter('name')],
        sorts: ['name'],
        selectedFromQuery: null,
        selectedRows: [],
    }),

    computed: {
        selectedGroups() {
            return this.alreadySelected.length > 0 ? this.alreadySelected : this.selectedFromQuery;
        },
    },

    watch: {
        open(open) {
            this.openModal = open;
        },
    },

    created() {
        if (this.enableQueryParams) {
            this.fillFromQueryParams();
        }
    },

    beforeUnmount() {
        this.openModal = false;
    },

    methods: {
        save(chosen) {
            if (this.enableQueryParams) {
                this.setQueryParams(chosen);
            }
            this.$emit('save', chosen);
        },

        close() {
            this.openModal = false;

            this.$emit('close');
        },

        remove(chosen) {
            this.$emit('remove', chosen);
            this.selectedFromQuery = [];
            this.removeQueryParams();
        },
    },
};
</script>

<style lang="scss" scoped>
.set-auto-height {
    height: auto !important;
}
.disabled-link {
    pointer-events: none;
    cursor: not-allowed;
    color: grey;
}
</style>
